import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { TFunction } from '@lyearn/i18n';
import { EyeOutline, MoreVertical, Trash2Outline } from '@lyearn/icons';
import { ActionMenu, ActionMenuProps } from '@lyearn/molecules';
import { LinkButton } from '@lyearn/ui';
import { ScorecardFragment } from '@/modules/corporate/modules/scorecards/graphql/fragments/generated/Scorecard';

export enum ScorecardActionEnums {
  Preview = 'PREVIEW',
  Remove = 'REMOVE',
}

const OVERRIDES: ActionMenuProps['overrides'] = {
  PopoverContent: {
    minWidth: 16,
    position: 'right-start',
  },
};

const scorecardActionItems = (t: TFunction): ActionMenuProps['items'] => [
  {
    id: ScorecardActionEnums.Preview,
    label: t('Common:Actions.Preview'),
    EndIcon: EyeOutline,
  },
  {
    id: ScorecardActionEnums.Remove,
    label: t('Common:Actions.Remove'),
    EndIcon: Trash2Outline,
    appearance: 'danger',
  },
];

function ScorecardActionMenu({
  onAction,
  scorecard,
}: {
  onAction: (actionType: ScorecardActionEnums, scorecard: ScorecardFragment) => void;
  scorecard: ScorecardFragment;
}) {
  const { t } = useTranslation();
  const onMenuAction = useCallback(
    (actionType: string) => {
      onAction(actionType as ScorecardActionEnums, scorecard);
    },
    [scorecard, onAction],
  );

  return (
    <ActionMenu items={scorecardActionItems(t)} overrides={OVERRIDES} onAction={onMenuAction}>
      <LinkButton color={'internal'}>
        <MoreVertical className="h-24 w-24" />
      </LinkButton>
    </ActionMenu>
  );
}

export default ScorecardActionMenu;
